// extracted by mini-css-extract-plugin
export default {"button":"OAuthButton__button___lufFq"};